import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class CredentialIssuanceService extends BaseApiService {
    public validateTransaction = (businessTransactionId: number): Observable<any> => this.get(`Driver/CredentialIssuanceApplication/Validate/${businessTransactionId}`);

    public validateLiteTransaction = (businessTransactionId: number): Observable<any> => this.get('Driver/CredentialIssuanceApplication/ValidateLite/' + businessTransactionId);

    public validateTransactionCredentialSelection = (businessTransactionId: number): Observable<any> => this.get(`Driver/CredentialIssuanceApplication/CredentialSelection/Validate/${businessTransactionId}`);

    public validateTransactionCustomer = (businessTransactionId: number): Observable<any> => this.get(`Driver/CredentialIssuanceApplication/Customer/Validate/${businessTransactionId}`);

    public validateTransactionQuestionnaire = (businessTransactionId: number): Observable<any> => this.get(`Driver/CredentialIssuanceApplication/Questionnaire/Validate/${businessTransactionId}`);

    public validateTransactionRequirements = (businessTransactionId: number): Observable<any> => this.get(`Driver/CredentialIssuanceApplication/Requirements/Validate/${businessTransactionId}`);
}
